import 'remixicon/fonts/remixicon.css';
import './src/global.scss';
import './src/utils/emoji.css';
